var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"file",staticStyle:{"float":"left"},attrs:{"href":"javascript:;"}},[_vm._v("选择文件\n\t\t\t"),_c('input',{ref:"files",attrs:{"type":"file","accept":_vm.accepttypes,"multiple":"multiple"},on:{"change":_vm.filechange}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93a55b18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload_img/uploadfileqt.vue
// module id = null
// module chunks = 